<template>
    <div class="drag-item">
        <v-icon 
            v-if="mobile? true : active"
            color="white"
            size="36px"
            class="icon icon-left"
            @click="moveDiv('left')">
            mdi-chevron-left
        </v-icon>
        <v-slide-group
            v-dragscroll.x:nochilddrag.stop="{ target: '.v-slide-group__wrapper', active: true }"
            multiple
            class="item-with-btns"
            @dragscrollstart="stopBubble('initial')" 
            @dragscrollmove="stopBubble" 
            @dragscrollend="returnBubble"
            center-active>
            <v-slide-item
                v-for="item in items"
                :key="item.id"
                @click.prevent
                v-slot:default="{}"
                class="item">
                <a 
                    :href="item.href"
                    class="item-link"
                    target="_blank" >
                    <img 
                        class="item-img"
                        :src="item.src"
                        alt=""
                        :style="item.style">
                </a>
            </v-slide-item>
            
        </v-slide-group>
        <v-icon 
            v-if="mobile? true : active"
            color="white"
            size="36px"
            class="icon icon-right" 
            @click="moveDiv('right')">
            mdi-chevron-right
        </v-icon>
    </div>
</template>

<script>

import { dragscroll } from 'vue-dragscroll'

export default {
    directives: {
        'dragscroll': dragscroll
    },
    data() {
        return {
            mobile: window.outerWidth < 480,
        }
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
        active: {
            type: Boolean,
            default: true
        }
    },
    methods: {

        stopBubble(phase) {
            if (phase) {
                let scrollDiv = document.querySelector(`.drag-item .v-slide-group__content`)
                scrollDiv.style.transform = ""
            }
            let links = document.querySelectorAll('.item-link')
            links.forEach( elem => (elem.onclick = event => event.preventDefault()))
        },
        returnBubble() {
            let links = document.querySelectorAll('.item-link')
            setTimeout(() => links.forEach((elem) => {elem.onclick = () => {return true;}}) ,100)
        },
        moveDiv: function(direction) {
            let container = document.querySelector(`.drag-item .v-slide-group__wrapper`)
            let scrollDiv = document.querySelector(`.drag-item .v-slide-group__content`)

            direction === 'left' ? 
                scrollDiv.style.transform = `translateX(0px)` : 
                scrollDiv.style.transform = `translateX(-${scrollDiv.offsetWidth - container.offsetWidth}px)`
        }

    },
}
</script>

<style lang="scss">
.drag-item {
    position: relative;

    .v-slide-group__next, .v-slide-group__prev {
        display: none;
    }
    .v-slide-group__wrapper {
        margin: 0 30px;
        transform: translateX(0px);
        transition: all 0.3s ease-out;
    }

    .v-slide-group__content {
        .item {
            &:first-child {
                margin-left: 10px !important;
            }
        }
    }

    .container {
        position: relative;
    }

    .icon {
        position: absolute;
        z-index: 950;
        top: 50%;
        transform: translateY(-50%);

        &.icon-right {
            right: 0;
        }
    }

    .item {
        width: 175px;
        height: 82.5px;
        margin:  0 15px;
        transition: all 0.2s ease-out;

        &.item-link, .item-link {
            display: flex;
            align-items: center;
            justify-content: center;
            background: $c-white;
            border-radius: 5px;

            &:hover {
                box-shadow: 0px 0px 12px 1px darkgray;
            }

            .item-img {
                max-width: 70%;
                max-height: 100%;
                object-fit: contain;
            }
        }
    }
}
</style>